import React from 'react';
import { ScrollView, Text, StyleSheet, View, Platform, TouchableOpacity } from 'react-native';
import CS from '../../constants/Styles';
import Colors from '../../constants/Colors';
import { Button, BackgroundGradient } from '../../components';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { FontAwesome5 } from '@expo/vector-icons';
import { useLinkTo } from '@react-navigation/native';
import Terms from './Terms';
import SignatureScreen from 'react-native-signature-canvas';
import { AntDesign } from '@expo/vector-icons';
// import { TextInput } from 'react-native-paper';

const TermsScreen = ({ navigation, route, ...props }) => {
  const [scrollEnabled, setScrollEnabled] = React.useState(true);
  // const [acceptedTerms, setAcceptedTerms] = React.useState(false);
  // const [signatureStarted, setSignatureStarted] = React.useState(false);


  const insets = useSafeAreaInsets();
  const linkTo = useLinkTo();

  React.useEffect(() => {
    checkSignUpProgress();
  }, []);

  const checkSignUpProgress = (route) => {
    if (!props.signUpProgress.EmailPassword) {
      linkTo('/login');
    }
  }

  const confirmTerms = () => {
    console.log('confirmTerms', props);
    props.setConfirmedTerms(true);
    props.completeStep('Terms');
  }

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      linkTo('/signup/emailpassword');
    }
  }

  // const ref = React.useRef();

  // const handleBegin = () => {
  //   console.log('handle begin');
  //   setScrollEnabled(false);
  // }
  // const handleSignature = signature => {
  //   // setSignature(signature);
  //   console.log('hande signature: ', signature);
  //   const path = FileSystem.cacheDirectory + 'rt_terms_signature.png';
  //   FileSystem.writeAsStringAsync(path, signature.replace('data:image/png;base64,', ''), { encoding: FileSystem.EncodingType.Base64 }).then(res => {
  //     console.log('res: ', res);
  //     FileSystem.getInfoAsync(path, { size: true, md5: true }).then(file => {
  //       console.log(file);
  //       setSignature(file);
  //     })
  //   }).catch(err => {
  //     console.log("err", err);
  //   });
  // };

  // const handleEmpty = () => {
  //   console.log('Empty');
  // }
  // const clearSignature = () => {
  //   console.log('clearSignature!');
  //   ref.current.clearSignature();
  //   setSignature(null);
  //   setScrollEnabled(true);
  // }
  // const handleClear = () => {
  //   // return;
  //   console.log('clear success!'); 
  // }
  // const handleEnd = () => {
  //   console.log('handle end');
  //   setScrollEnabled(true);
  //   ref.current.readSignature();
  // }
//   const webStyle = `.m-signature-pad--footer
//     .save {
//         display: none;
//     }
//     .clear {
//         display: none;
//     }
//     .m-signature-pad--footer { display: none; margin: 0px; }
// `;

//   const nameInput = () => {
//     return (
//       <TextInput
//         mode='flat'
//         // label='Full Name'
//         value={signatureText}
//         placeholder='Full Name'
//         onChangeText={t => setSignatureText(t)}
//         underlineColor={Colors.yellow}
//         selectionColor={Colors.yellow}
//         placeholderTextColor={Colors.yellow}
//         style={{ padding: 5, backgroundColor: 'transparent', height: 20, paddingHorizontal: 5, color: Colors.yellow, textAlign: 'center' }}
//       />
//     )
//   }

  return (
    <View style={CS.container}>
      <BackgroundGradient />
      <ScrollView style={styles.terms} contentContainerStyle={[styles.innerContainer, { paddingTop: insets.top, paddingBottom: insets.bottom }]} scrollEnabled={scrollEnabled}>
        <TouchableOpacity onPress={goBack} style={{ marginTop: 10, marginBottom: 20, justifyContent: 'center' }}>
          <FontAwesome5 name="arrow-left" size={24} color="white" style={{ position: 'absolute' }} />
          <Text style={[CS.mediumTitle, CS.lightText, CS.centerText, { marginVertical: 0}]}>Terms of Use</Text>
        </TouchableOpacity>
        <Terms
          signatureText={props.signatureText}
          setSignatureText={props.setSignatureText}
          signature={props.signature}
          setSignature={props.setSignature}
          confirmTerms={confirmTerms}
          setScrollEnabled={setScrollEnabled}
        />
        {/* {Platform.OS === 'web'
          ?
          <Text style={[CS.smallText, CS.lightText, CS.boldText, { marginVertical: 20 }]}><Text style={CS.capsLock}>I, {nameInput()} have carefully read</Text> this agreement and fully understand its contents. This contract shall be legally binding upon me, my heirs, my estate, assigns, legal guardians and my personal representatives.</Text>
          :
          <>
            <Text style={[CS.smallText, CS.lightText, CS.boldText, { marginVertical: 20 }]}><Text style={CS.capsLock}>I have carefully read</Text> this agreement and fully understand its contents. This contract shall be legally binding upon me, my heirs, my estate, assigns, legal guardians and my personal representatives.</Text>
            <View style={{ marginBottom: 20, flex: 1, }}>
              <TouchableOpacity activeOpacity={0.6} onPress={clearSignature} style={{ position: 'absolute', top: 5, right: 5, zIndex: 100 }}>
                <AntDesign name="closecircle" size={24} color={Colors.blue2} />
              </TouchableOpacity>
              <SignatureScreen
                ref={ref}
                onEnd={handleEnd}
                onOK={handleSignature}
                onBegin={handleBegin}
                onEnd={handleEnd}
                onEmpty={handleEmpty}
                onClear={handleClear}
                // descriptionText='Full Name'
                penColor={Colors.blue2}
                webStyle={webStyle}
                style={{ height: 120, }}
                autoClear={false}
                trimWhitespace={true}
              />
              <Text style={[CS.mediumText, CS.lightText, CS.centerText, { padding: 10, borderWidth: 1, borderColor: 'white', backgroundColor: Colors.blue2 }]}>Sign your full name above</Text>
            </View>
          </>
        }
        <Button text='I Agree to the Terms of Use' onPress={() => confirmTerms} disabled={!signature} /> */}
      </ScrollView>
    </View>
  )
}

const styles = StyleSheet.create({
  innerContainer: {
    width: '100%',
    // backgroundColor: 'pink',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',
    flexGrow: 1,
  },
  terms: {
    // marginTop: 20,
    marginVertical: 10,
    // backgroundColor: 'orange',
  },
});

export default TermsScreen;